<div class="row justify-content-center">

    <div>

        <div class="mat-elevation-z8" style="height: 164px; color: white;
                                                border-radius: 0px 0px 0px 0px ;
                                                border: 5px solid rgb(98, 126, 138);
                                                background-image: Radial-gradient(rgb(240, 240, 240), rgb(220, 220, 220), rgb(160, 160, 160));">
                <br/>
                <div class="text-center font-weight-normal " style="position: relative; left :50px;
                                                                    height: 100px;    ">
                    <app-banner></app-banner>
                </div>
                
                <div style="text-align: center; ">
                    <div style="width: 100%; height: 30px;
                                background-color:rgb(55, 169, 87);
                                border-radius: 50px 50px 0px 0px ;
                                font-family:Georgia, 'Times New Roman', Times, serif;
                                font-size: 20px; letter-spacing: 0px;">
                                Easy Quality
                    </div>

                </div>
        </div>

        <mat-card class="mat-elevation-z8" *ngIf="linkDNS == ''" style="height: 320px; margin-top: 10px;
                                                                        border: 5px solid rgb(98, 126, 138);
                                                                        border-radius: 0px 0px 0px 0px; ">

                <div style="width: 100%; text-align: center;  ">
                    <img src="../../assets/img/logoQualidade.png" width="150px">
                </div>

                <form  [formGroup]="formLogin" novalidate (ngSubmit)="entrar()" *ngIf="login">
                    <br/>
                    <div>
                        <img src="../../assets/img/icones/usuarios.png" width="30px">&nbsp;
                        <mat-form-field appearance="outline" style="width: 220px;  font-size: 12px;">
                            <mat-label>Numero do Registro  &nbsp;( RE )</mat-label>
                            <input matInput placeholder="usuario" formControlName="usuario" >
                        </mat-form-field>
                    </div>

                    <div>
                        <img src="../../assets/img/icones/chave.png" width="25px" >&nbsp;&nbsp;
                        <mat-form-field appearance="outline" style="width: 220px; font-size: 12px;">
                            <mat-label>Senha</mat-label>
                            <input matInput  [type]="hide ? 'password' : 'text'" formControlName="senha">
                            <button mat-icon-button type="button" matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <br/>

                    <div style="float: left;width: 50%; font-size: 12px; color: blue;">
                        <div *ngIf="!aguarde" style="width: 100%; text-align: right;">
                            <button mat-raised-button  type="submit" style="width: 120px;background-color:rgb(46, 163, 80);  color: white;" >
                                Entrar
                            </button>
                        </div>
                    </div>
                    <div style="float: left;width: 50%;">
                        <div *ngIf="!aguarde" style="width: 100%; text-align: right;">
                            <button mat-raised-button style="width: 120px;background-color:rgb(254, 154, 4);  color: white;" (click)="newPass('senha')">
                                Nova Senha
                            </button>
                        </div>
                    </div>


                </form>

                <!-- INICIO FORM CADASTRAR SENHA-->
                <form  [formGroup]="formLogin" novalidate (ngSubmit)="novaSenha()" *ngIf="senha">
                    <br/>
                    <div>
                        <img src="../../assets/img/icones/usuarios.png" width="30px">&nbsp;
                        <mat-form-field appearance="outline" style="width: 220px;  font-size: 12px;">
                            <mat-label>Numero do Registro  &nbsp;( RE )</mat-label>
                            <input matInput placeholder="usuario" formControlName="usuario" >
                        </mat-form-field>
                    </div>

                    <div>
                        <img src="../../assets/img/icones/chave.png" width="25px" >&nbsp;&nbsp;
                        <mat-form-field appearance="outline" style="width: 220px; font-size: 12px;">
                            <mat-label>Nova senha</mat-label>
                            <input matInput  [type]="hide ? 'password' : 'text'" formControlName="senha">
                            <button mat-icon-button type="button" matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

                    <br/>

                    <div style="float: left;width: 50%; font-size: 12px; color: blue;">
                        <div *ngIf="!aguarde" style="width: 100%; text-align: right;">
                            <button mat-raised-button  type="submit" style="width: 120px;background-color:rgb(98, 126, 138);  color: white;" >
                                Atualizar
                            </button>
                        </div>
                    </div>
                    <div style="float: left;width: 50%;">
                        <div *ngIf="!aguarde" style="width: 100%; text-align: right;">
                            <button mat-raised-button style="width: 120px;background-color:rgb(254, 154, 4);  color: white;" (click)="newPass('login')">
                                Cancelar
                            </button>
                        </div>
                    </div>


                </form>

                <!-- FIM FORM CADASTRAR SENHA-->
                <br/><br/>
                   <label style="width: 100%; text-align: right; font-size: 11px;"> Versão : 1.2.0 &nbsp;</label>


            </mat-card>


            <mat-card class="mat-elevation-z8" *ngIf="linkDNS != ''" style="height: 100px; margin-top: 10px; text-align: center;
                                                                            border: 5px solid rgb(98, 126, 138);
                                                                            border-radius: 0px 0px 0px 0px; ">
            

            <label style="color: red; font-weight: 600;">FAVOR ACESSAR A APLICAÇÃO PELO LINK:</label>
            <br/>
            <a href="{{linkDNS}}">{{linkDNS}}</a>
            
            </mat-card>
            <mat-card class="mat-elevation-z8" *ngIf="linkDNS != ''" style="height: 100px; margin-top: 10px; text-align: center;
                                                                            border: 5px solid rgb(98, 126, 138);
                                                                            border-radius: 0px 0px 0px 0px; ">
            

                    <label style="color: red; font-weight: 600;">FAVOR ACESSAR A APLICAÇÃO PELO LINK:</label>
                    <br/>
                    <a href="{{linkDNS}}">{{linkDNS}}</a>
                    
                    
                    
            </mat-card>


    </div>
</div>
